import getParents from "./getParents";

export default class AnchorScroll {

    /*
    options:
        offset : 0
        shrink : false
        hideUri : false
        scrollDuration : 1200
     */

    /*
    examples:
        <a data-anchor="" href="#target">Anchor</a>
        <a data-anchor="" data-hide-uri="" href="#target">Anchor</a>
        <div data-anchor="" data-target="#target">Anchor</div>
        <a href="#" data-hide-uri="" data-scroll-top="">To Top</a>
     */

    /*
    events :
        anchor-scroll-before
        anchor-scroll-after
     */

    constructor(options) {
        if (options === undefined) {
            options = {};
        }
        this.options = {
            shrink: options.shrink ? options.shrink : false,
            hideUri: options.hideUri ? options.hideUri : false,
            scrollDuration: options.scrollDuration ? options.scrollDuration : 1200
        }
        window.addEventListener('load', (e) => {
            this.init();
        });
    }

    init() {
        let elements = document.querySelectorAll('[data-anchor]')
        if (elements.length) {
            elements.forEach((v, k) => {
                v.addEventListener('click', (event) => {
                    if (this.scrollToElement(v)) {
                        event.preventDefault();
                        return false;
                    }
                });
            });
        }
        if (location.hash !== "") {
            this.scrollToElement({dataset: []}, location.hash);
        }
        elements = document.querySelectorAll('[data-scroll-top]');
        if (elements.length) {
            elements.forEach((v, k) => {
                v.addEventListener('click', (event) => {
                    this.scrollToElement(v, 'body');
                    event.preventDefault();
                    return false;
                });
            });
        }
    }

    scrollToElement(target, anchor) {
        let anchorElement = this.getAnchorElement(target, anchor);
        if (!anchorElement)
            return false;

        let aosInitElements = getParents(anchorElement, '.aos-init').length;
        let aosAnimateElements = getParents(anchorElement, '.aos-animate').length;
        let offset = 0;
        if ((aosInitElements !== aosAnimateElements && aosInitElements > 0) ||
            (anchorElement.classList.contains('aos-init') && !anchorElement.classList.contains('aos-animate'))) {
            offset = -100;
        }
        let header = document.querySelector('header');
        offset -= header.offsetHeight;
        if (this.options.shrink && !header.classList.contains('sticky')) {
            offset += 40;
        }
        if (target.dataset["offset"]) {
            offset += target.dataset["offset"];
        }
        window.dispatchEvent(new CustomEvent('anchor-scroll-before', {
            detail: {
                target: target,
                anchor: anchorElement
            }
        }));
        window.scrollTo(0, window.scrollY + offset + anchorElement.getBoundingClientRect().top);
        window.dispatchEvent(new CustomEvent('anchor-scroll-after', {
            detail: {
                target: target,
                anchor: anchorElement
            }
        }));
        if (!(this.options.hideUri || target.dataset["hideUri"] !== undefined)) {
            if (typeof anchor !== "string") {
                anchor = "#" + anchorElement.getAttribute('id');
            }
            history.pushState({}, '', location.origin + location.pathname + anchor);
        }
        return true;
    }

    scrollToHash() {
        if (location.hash !== "") {
            this.scrollToElement({dataset: []}, location.hash);
        }
    }

    getAnchorElement(target, anchor) {
        if (!anchor) {
            if (target.dataset["target"]) {
                anchor = target.dataset["target"];
            } else if (target.getAttribute('href')) {
                anchor = target.getAttribute('href');
                let anchorIndex = anchor.indexOf('#');
                if (anchorIndex !== 0) {
                    if (anchor.indexOf(location.pathname) === 0) {
                        anchor = anchor.substr(location.pathname.length);
                    }
                    if (("/" + anchor).indexOf(location.pathname) === 0) {
                        anchor = anchor.substr(location.pathname.length - 1);
                    }
                }
            }
        }
        if (anchor === null || anchor.length === 0) return false;
        if (typeof anchor === "string") {
            anchor = document.querySelector(anchor);
        }
        return anchor;
    }
}
